import { Body, Controller, Post, Req, UploadedFiles, UseInterceptors } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import { PaymentsService } from "./payments.service";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { CommonResponseModel, PaymentIdRequest, UploadResponse } from "@project-management-system/shared-models";
import { PaymentsDTO } from "./dto/payments-dto";
import { FilesInterceptor } from '@nestjs/platform-express';
import { diskStorage } from 'multer';
import { extname, join } from 'path';
@ApiTags('payments')
@Controller('payments')
export class PaymentsController {
    constructor(private paymentsService: PaymentsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
        ) {}

    @Post('/createPayment')
    @ApiBody({ type: PaymentsDTO })
    async createPayment(@Body() paymentsDTO:any,isUpdate:boolean=false): Promise<CommonResponseModel> {
        try {
            return await this.paymentsService.createPayment(paymentsDTO, false);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/getAllPaymentsRequests')
    async getAllPaymentsRequests(): Promise<CommonResponseModel> {
        try {
            return await this.paymentsService.getAllPaymentsRequests();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/uploadPaymentDocs')
  @UseInterceptors(FilesInterceptor('file', 10, {
    storage: diskStorage({
      destination: (req, file, callback) => {
        callback(null, join(__dirname, '../../../../',`upload_files`));
      },
      filename: (req, file, callback) => {
        // console.log(req);
        // console.log(file);
        // console.log("************************************************************************************************");
        const name = `Payments-${(req.body.reqNo).replace(/\//g, "_")}_`+file.originalname.split('.')[0];
        const fileExtName = extname(file.originalname);
        const randomName = Array(4)
          .fill(null)
          .map(() => Math.round(Math.random() * 16).toString(16))
          .join('');
        callback(null, `${name}-${randomName}${fileExtName}`);
      },
    }),
    fileFilter: (req, file, callback) => {
      if (!file.originalname.match(/\.(xlsx|xls|pdf|jpg|png|jpeg|doc|PDF)$/)) {
        return callback(new Error('Only xlsx,xls,pdf, jpg, png, doc, jpeg files are allowed!'), false);
      }
      callback(null, true);
    },
  }))
  async uploadPaymentDocs(@UploadedFiles() file: File[], @Body() uploadData: any): Promise<UploadResponse> {
    try {
      return await this.paymentsService.uploadPaymentDocs(file, uploadData)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(UploadResponse, error);
    }
  }

  @Post('/updatePaymentStatus')
  @ApiBody({ type: PaymentIdRequest })
  async updatePaymentStatus(@Body() req:any,): Promise<CommonResponseModel> {
      try {
          return await this.paymentsService.updatePaymentStatus(req);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
      }
  }

}